<template>
    <div class="beerRecord">
      <span><u>{{ __('page_setbeers.headerbeer', [index + 1]) }}</u></span>
        <dt>
            <label class="required labelText">{{ __('page_setbeers.category') }}</label>
        </dt>
        <dd>
            <select :id="`category${index}`" :name="`category${index}`" required v-model="value.category"
                    @change="changeCategory($event, index)"
                    @blur="validator.validateCategory()"
                    class="XXL inputText">
                <option value="">{{ __('common.please_select') }}</option>
                <option v-for="category in categories" :key="category.id" :value="category.id">
                    {{ category.id_category }} {{ $store.language === 'de' ? category.name_de : category.name_en }}
                </option>
            </select>
            <div class="errorMessages" v-if="errors.category">
                <ErrorMessage>{{__(errors.category)}}</ErrorMessage>
            </div>
        </dd>

        <dt>
            <label class="required labelText">{{ __('page_setbeers.nameofbeer') }}</label>
        </dt>
        <dd>
            <input type="text" :id="`beer${index}`" :name="`beer${index}`" v-model="value.name" class="XXL inputText"
              @input="handleNameChange">
            <div class="errorMessages" v-if="errors.name">
                <ErrorMessage>{{__(errors.name)}}</ErrorMessage>
            </div>
            <div class="errorMessages" v-if="nameError">
                <ErrorMessage>{{ nameError }}</ErrorMessage>
            </div>
        </dd>

        <table style="width: 100%;" class="mb-2">
          <tr>
            <td  class="w-2/4 pr-1">
              <label class="required labelText">{{ __('page_setbeers.alcvol') }}</label>
            </td>
            <td  class="w-2/4 pl-1">
              <label class="required labelText">{{ __('page_setbeers.wortvol') }}</label>
            </td>
          </tr>
          <tr>
            <td class="w-2/4 pr-1"> 
              <decimal-input class="XXL inputText" required v-model="value.alcVol"
                   @input="validator.validateAlcVol()" />
              <div class="errorMessages" v-if="errors.alcVol">
                  <ErrorMessage style="max-width: 260px;">{{__(errors.alcVol.msg, errors.alcVol.opt)}}</ErrorMessage>
            </div>
          </td>
            <td class="w-2/4 pl-1">
              <decimal-input v-model="value.wortVol" required class="XXL inputText"
                   @input="validator.validateWortVol()"/>
              <div class="errorMessages" v-if="errors.wortVol">
                  <ErrorMessage style="max-width: 260px;">{{__(errors.wortVol.msg, errors.wortVol.opt)}}</ErrorMessage>
              </div>
            </td>
          </tr>
        </table>

        <dt v-if="(this.isQueryCategory)">
        <label class="required labelText">
            {{ this.language === 'de' ? queryTextDE  : queryTextEN }}
            <span style="color:#AAAAAA; font-weight: bolder; margin-right: 150px; font-size: small; float:right">
                ({{ counter }}/200)
            </span>      
        </label>
       
      </dt>
      <dd v-if="(this.isQueryCategory)">
        <input type="text" :id="`query_response${index}`" :name="`query_response${index}`" v-model="value.query_response"
          class="XXL inputText" @input="updateCounter()" @blur="validator.validateQueryResponse()">
        <div class="errorMessages" v-if="errors.query_response">
          <ErrorMessage style="max-width: 260px;">{{__(errors.query_response)}}</ErrorMessage>
        </div>
      </dd>


        <dt v-if="showUploadFile">
            <label>Datei hochladen</label>
        </dt>
        <dd v-if="showUploadFile">
          <input id="`mediaFile${index}`" name="`mediaFile${index}`" @change="handleImage" type="file" accept="application/pdf" />
        </dd>


        <dd>
            <button type="button" class="L" style="margin-left: 0;" v-on:click="$emit('remove')">
                {{ __('page_setbeers.removebeer') }}
            </button>
        </dd>
    </div>
</template>

<script>
    import ErrorMessage from "./ErrorMessage";
    import Lang from "../mixins/Lang";
    import DecimalInput from "./DecimalInput";

    export default {
        name: "BeerRecord",
        components: {DecimalInput, ErrorMessage},
        props: ['beer', 'index', 'value', 'validator', 'nameError'], // Add 'nameError' prop
        store: [
            'additionalBeerCategoriesWithBeerType',
            'language',
            'previousContent',
            'categories'
        ],
        mixins: [Lang],

        data: () => {
            return {
                alternativeCerealInputStarted: false,
                belgianBeerTypeInputStarted: false,
                queryTextDE: '',
                queryTextEN: '',
                isQueryCategory: false,
                showUploadFile: false,
                counter: 0,
            };
        },

        watch : {

        },

        methods : {
            translate(obj) {
                if(this.language === 'de') {
                    return obj.name_de;
                } else {
                    return obj.name_en;
                }
            },


          handleImage(e) {
            const selectedImage = e.target.files[0]; // get first file

            if (selectedImage.size > 625000) {
              this.value.media_file = '';
              alert('Es ist nicht möglich, die Datei hochzuladen. Die Größe übersteigt 5 MB.');
            }
            else {
              if (selectedImage.type === 'application/pdf') {
                this.createBase64Image(selectedImage);
              }
              else {
                this.value.media_file = '';
              }
            }
          },

          createBase64Image(fileObject) {
            const reader = new FileReader();
            reader.onload = (e) => {
              this.value.media_file = e.target.result;
            };
            reader.readAsDataURL(fileObject);
          },

          changeCategory(event) {
            var categoryID = event.target.value ;
            this.activateCategoryQuery(categoryID);
          },

          activateCategoryQuery(categoryID){
            // console.log('activateCategoryQuery categoryID',categoryID);
            if (!categoryID) {return;}
            var category = this.getCategory(categoryID);            
            this.queryTextDE = '';
            this.queryTextEN = '';
            this.isQueryCategory = category['is_query'];
            if (category['is_query']) {
              if (category['categories_translation'].length > 0) {
                if (this.language === 'de') {
                  this.queryTextDE = category['categories_translation'][0]['translation'];
                }
                if (this.language === 'en') {
                  this.queryTextEN = category['categories_translation'][1]['translation'];
                }
              }
            }
            this.showUploadFile = false;
            if (category['is_fileupload']) {
              this.showUploadFile = true;
            }
          },

          getCategory(categoryID) {
            var category = this.categories.filter((category) => category.id == categoryID);
            return category[0];
          },

          updateCounter() {
              this.counter = this.value.query_response.length;
              if (this.counter > 200) {
                  this.value.query_response = this.value.query_response.substring(0, 200);
                  this.counter = 200;
              }
          },

          handleNameChange() {
              this.validator.validateName();
              this.$emit('nameChanged', { name: this.value.name, index: this.index });
          }
        },
        
        // before loading component 
        beforeMount() {          
          this.activateCategoryQuery(this.category.id);
        },



        computed: {
          category: function () {
            var cat = this.categories.find((category) => {
              return category.id === this.value.category;
            });
            return cat || {};
          },

            errors() {
                return this.validator.errors;
            },

            remaining() {
                return 200 - this.counter;
            }
        }
    }
</script>

<style scoped>

</style>